import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { httpWithAuth } from '~/clients';
import { CREDIT_STATUS } from '~/constants/endpoints';
import FinanceAndTradeContext from '~/contexts/FinanceAndTradeContext';
import { useUserData } from '~/contexts/UserContext';
import { CreditStatus, FinancingPolicy } from '~/contracts';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetCreditStatus() {
  const { isLoggedIn } = useUserData();
  const { updateSoftPull } = useContext(FinanceAndTradeContext);

  useEffectWithController(
    controller => {
      if (!isLoggedIn) return;

      httpWithAuth
        .get<{ creditStatus: CreditStatus; financingPolicy: FinancingPolicy }>(
          CREDIT_STATUS,
          {
            headers: { 'X-Cvna-Finx-Clientsource': 'srp' },
            signal: controller.signal
          }
        )
        .then(res => {
          updateSoftPull({
            hasExpiredSoftPull: res.data?.creditStatus?.hasExpiredSoftPull,
            hasValidSoftPull: res.data?.creditStatus?.hasValidSoftPull
          });
        })
        .catch(generateErrorLogger('Credit Status', {}));
    },
    [isLoggedIn, updateSoftPull]
  );
}
